package com.eladfinish.bible.contest.features.verseWidget

import com.eladfinish.bible.contest.platform.isAndroid
import com.eladfinish.bible.contest.platform.isIos

/** The widget lives on a phone's home screen: web and desktop have no tile and no screen for it. */
val isVerseWidgetPlatform: Boolean
    get() = isAndroid || isIos
